import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../Error/error';
import { toast } from 'react-toastify';
import cookie from 'react-cookies';
import Moment from 'moment';
import $ from "jquery";
import DatePicker, { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
// registerLocale('es', es)
import EventosExcel from '../Reportes/eventosExcel';
import {DropDownList} from '../../Elements/Select/dropdown';
// import {approveRole} from '../../../functions';
// import EventPagination from '../../Elements/Pagination/eventpagination';

class Eventos extends Component {
    constructor (props){
        super(props);
        this.state = {
            pagina:     1,
            loading:    true,
            data:       [],
            error:      [],
            roles:      [],
            response:   [],
            users:      [],
            security:   cookie.load('user'),
            
            filtroYYYY:0,
            filtroMM:0,
            filtroSector:0,
            filtroTipo:0,
            searchText: "",
            mensajeResultado:""
        }

        this.getData = this.getData.bind(this);
        this.getDataByPagination = this.getDataByPagination.bind(this);
        this.handleInputTextChange = this.handleInputTextChange.bind(this);
        this.excelRef = React.createRef();

    }

    getUsers (ids) {
        let idArray = [];

        ids.map((item) => {
            if(!idArray.includes(item)){
                idArray.push(item);
            }
        });

        const url = `${API_URL}UsuarioUX/ObtenerUsuariosPorIds/${idArray}`;
        axios.get(url).then(response => response.data)
        .then((data) => {

            this.setState({ 
                users:      data.result, 
                loading:    false
            });

            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");

        }).catch(error => {
            document.querySelector('.loader').classList.add('loader--hide');
            toast.error('Error de comunicación');
        });
        
    }

    getData ( filtro="", page = "") {
        const YYYY = this.state.filtroYYYY ?? 0;
        const MM = this.state.filtroMM ?? 0;
        const sector =  this.state.filtroSector ?? 0; 
        let tipo =  this.state.filtroTipo ?? 'ALL'; 
            if (tipo.length==0) {tipo="ALL"}
        const search = this.state.searchText;

        if(document.querySelector('.loader').classList.contains('loader--hide')){
            document.querySelector('.loader').classList.remove('loader--hide');
            document.getElementById('content-wrapper').setAttribute("hidden", true);
        }

        if(page === ""){page = 1;}
        this.setState({pagina: page});

        // var roles = this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; });
        // var flag = approveRole(roles);
        // var estados= (flag?('R,A,P'):('R'));
        // var usuario = (flag ? (0) : (this.state.security.nUsuCodigo));

        var filters = search === "" ? 'ALL': search;

        const url = `${API_URL}EventUX/${page}/X/0/${YYYY}/${MM}/${sector}/${tipo}/${filters}`;
        console.clear()

        axios.get(url).then(response => response.data)
        .then((data) => {

            let usersList = data.result.map((item) => item.even_UsuarioCreacion);
            this.setState({ 
                data:       data.result, 
                response:   data, 
                error:      data.Error,
                loading:    false
            }, () => {
                if(this.state.data.length > 0){
                    this.getUsers(usersList);
                }else{
                    document.querySelector('.loader').classList.add('loader--hide');
                    document.getElementById('content-wrapper').removeAttribute("hidden");
                }
            });

            // document.querySelector('.loader').classList.add('loader--hide');
            // document.getElementById('content-wrapper').removeAttribute("hidden");
            
        }).catch(error => {
            // document.querySelector('.loader').classList.add('loader--hide');
            toast.error('Error de comunicación');
        });
    }

    getDataXLS() {
    return new Promise((resolve, reject) => {
        const YYYY = this.state.filtroYYYY ?? 0;
        const MM = this.state.filtroMM ?? 0;
        const sector = this.state.filtroSector ?? 0;
        let tipo = this.state.filtroTipo ?? 'ALL';
        if (tipo.length === 0) { tipo = "ALL"; }
        const search = this.state.searchText;
        const filters = search === "" ? 'ALL' : search;
        const urlX = `${API_URL}EventUX/${-1}/X/0/${YYYY}/${MM}/${sector}/${tipo}/${filters}`;
        if (document.querySelector('.loader').classList.contains('loader--hide')) {
            document.querySelector('.loader').classList.remove('loader--hide');
            document.getElementById('content-wrapper').setAttribute("hidden", true);
        }
        axios.get(urlX).then(response => response.data)
        .then((data) => {
            this.setState({
                datax: data.result,
                response:   data, 
                error: data.Error,
                loading: false
            }, () => {
            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");
            resolve();  
            });
        })
        .catch((error) => {
            toast.error('Error de comunicación');
            reject(error); 
        });
    });
    }


    componentDidMount(){
        var flag = localStorage.getItem("load")

        if (flag === false) {
            window.location.reload();
            localStorage.setItem("load", true);
        }

        if (localStorage.getItem("load") === null || flag === "false") {
            window.location.reload();
            localStorage.setItem("load", true);
        }

        const url = `${API_URL}ParameterUX/ENLACE_WEB`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            this.setState({ urlweb: data.result[0]?.sValor });
        })
        .catch(error => {
            alert('Error de comunicación: get url web');
        });   
        this.getData("", "1");
        
    }

    handleInputTextChange(event){
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ 
            searchText: value
        });
    }
 

    searchEvent(){
        this.getData(this.state.searchText, "1");
    }

    getDataByPagination(page){
        this.getData(this.state.searchText, `${page}`);
    }

    addResource(){
        this.props.history.push({
            pathname: '/add-evento',
            state: { key: 0}
        });
    }

    editEvent(id){
        this.props.history.push({
            pathname: '/editar-evento/' + id,
            state: { key: id }
          });
    }

    paginationTable(){
        var entity = this.state.data.length > 0 ? this.state.data[0] : null;
        const options = [];

        if (entity !== null){

            if(entity.totalPages == 1){
                return null;
            }

            options.push(
                <a 
                    className="btnPrevPaginador" 
                    id={0} 
                    key={0} 
                    onClick={(e) => Number(this.state.pagina) <= 1 ? "" : this.getData(this.state.searchText, `${Number(this.state.pagina) - 1}`)}
                ></a>
            );
            
            for(let index = 1; index < entity.totalPages + 1; index++){
                options.push(
                    <a 
                        id={index} 
                        key={index} 
                        onClick={(e) => this.getData(this.state.searchText, `${index}`)}
                        className={(index.toString() === this.state.pagina.toString() ? "active" : "") + " pageItem"}
                    > 
                        {index} 
                    </a>
                );
            }

            options.push(
                <a 
                    className="btnNextPaginador" 
                    id={entity.totalPages+1} 
                    key={entity.totalPages+1} 
                    onClick={(e) => entity.totalPages.toString() === this.state.pagina.toString() ? "" : this.getData(this.state.searchText, `${Number(this.state.pagina) + 1}`)}
                ></a>
            );

            return (
                <div className="divPaginador" key={"pagination"} id="pagination">
                    {options}
                </div>
            );
        }
    }

    resetFilters = () => {
        this.setState({
            filtroYYYY:0,
            filtroMM:0,
            filtroSector:0,
            filtroTipo:0,
            searchText: "",
        });
    }

    // generaCalendarioEnPDF(){

       
        // }
    generaCalendarioEnPDF = async () => {
        // const URL_WEB_GENERA_PDF = 'https://devexportemos.promperu.gob.pe/promociona-tu-oferta-exportable/calendario-de-eventos-promocion-comercial/pdf/cms';
        let URL_WEB_GENERA_PDF =  (this.state.urlweb ?? '') + 'promociona-tu-oferta-exportable/calendario-de-eventos-promocion-comercial/pdf/cms';
        if (this.state.loading) {this.setState({ mensajeResultado: "Aguarde un momento..." });return;}
        this.setState({ loading: true, mensajeResultado: "Procesando..." });

        try {
            const response = await fetch(URL_WEB_GENERA_PDF);

            if (!response.ok) {
            if (response.status === 429) {
                const json = await response.json();
                this.setState({ mensajeResultado: json.mensaje || "Ya se está generando otro calendario, reintente en unos momentos." });
            } else {
                const json = await response.json().catch(() => null);
                throw new Error(json?.mensaje || `Error al generar el PDF. Código: ${response.status}`);
            }
            return;
            }

            const result = await response.json();
            if (!result.ok) throw new Error(result.mensaje || "Error inesperado");

            const cuando = this.formatearFecha(new Date());
            this.setState({ mensajeResultado: `Calendario generado correctamente. (${cuando})` });

        } catch (error) {
            console.error("Error al generar el PDF:", error.message);
            this.setState({ mensajeResultado: error.message || "No se pudo generar el PDF." });
        } finally {
            this.setState({ loading: false });
        }
        
    };


	 formatearFecha(fecha = new Date()) {
		const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
		const dd = String(fecha.getDate()).padStart(2, '0');
		const mmm = meses[fecha.getMonth()];
		const yyyy = fecha.getFullYear();
		const hh = String(fecha.getHours()).padStart(2, '0');
		const mm = String(fecha.getMinutes()).padStart(2, '0');
		return `${dd}-${mmm}-${yyyy} ${hh}:${mm}`;
	}

    render() {
        Moment.updateLocale('en', {
            months : ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio","Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"]
        });

        Moment.updateLocale('en', {
            weekdays : ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]
        });

        return (
            (this.state.response.statusCode == 200) ?
                <div>
                    <div id="detailBody" className="Site-content">
                        <div className="loader"></div>
                        <div hidden={true} id="content-wrapper">
                            <div id="content">
                                <div id="Body" className="body-container">
                                    <div className="divContenedorBreadcrumbs">
                                        <div className="divCenterBreadcrumbs">
                                            <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                                                <a href="/">
                                                    / Panel de configuración general
                                                </a>
                                                <Link to="/administradores">
                                                    / Administradores
                                                </Link>
                                            <span> / Eventos</span>
                                        </div>
                                    </div>
                                    <div className="divTitulo_Panel mb-3">
                                        Eventos
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12 col-lg-11 mx-auto">

                                            <div className="divCatAnadir_Panel">
                                                    <div id='filters' className="divCatAnadir_Panel mb-3">
                                                        <div className="row align-items-end">
                                                            <div className="col-lg-3">
                                                            <div className="row">
                                                                <div className="col-12 mb-2 divSectorSearch_Panel ">
                                                                    Periodo del evento:<br></br>
                                                                <div className="d-flex gap-2">
                                                                    <select name="filtroYYYY"
                                                                        className="form-control form-control-sm w-50"
                                                                        value={this.state.filtroYYYY}
                                                                        onChange={(e) => this.setState({ filtroYYYY: e.target.value })}
                                                                    >
                                                                        <option value="0">Año</option>
                                                                        {[...Array(3)].map((_, i) => {
                                                                            const currentYear = new Date().getFullYear();
                                                                            const year = currentYear - 1 + i;
                                                                        return (
                                                                        <option key={year} value={year}>
                                                                         {year}
                                                                        </option>
                                                                        );
                                                                        })}
                                                                    </select>
                                                                    <select
                                                                       name="filtroMM"
                                                                        className="form-control form-control-sm w-50"
                                                                        value={this.state.filtroMM}
                                                                        onChange={(e) => this.setState({ filtroMM: e.target.value })}
                                                                    >
                                                                    <option value="0">Mes</option>
                                                                    {[...Array(12).keys()].map((m) => (
                                                                        <option key={m + 1} value={m + 1}>
                                                                        {new Date(0, m).toLocaleString('es', { month: 'long' })}
                                                                        </option>
                                                                    ))}
                                                                    </select>
                                                                </div>
                                                                </div>
                                                                
                                              

                                                                <div className="col-6">
                                                                    <a href="#" className="btnAnadirCat noneEvent btnCallToActionCMS"
                                                                        onClick={() => this.addResource()}
                                                                    > NUEVO </a>
                                                                </div>
                                                                <div className="col-6">
                                                                      <button type='reset' onClick={() => this.resetFilters()} className='btn btn-secondary d-block w-100 py-1 btnCallToActionCMS btnCallPlomo'
                                                                      >LIMPIAR FILTRO</button>
                                                                </div>
                                                            </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                            <div className="row">
                                                                <div className="col-lg-6">
                                                                <div className="mb-2">
                                                                    Sector:<br></br>
                                                                     <DropDownList metodo={"edit"} valor={this.state.filtroSector}  name="filtroSector" id="filtroSector"
                                                                        componente={"EventSector"} id_sin_guion={true}
                                                                        onChange={(e) => { this.setState({ filtroSector: e.target.value?.value }); }}
                                                                    />
                                                                </div>
                                                                </div>

                                                                <div className="col-lg-6">
                                                                <div className="mb-2">
                                                                        Tipo<br></br>
                                                                      <DropDownList metodo={"edit"} valor={this.state.filtroTipo}  name="filtroTipo" id="filtroTipo"  
                                                                        componente={"Even_Tipo"} 
                                                                        onChange={(e) => { this.setState({ filtroTipo: e.target.value?.value }); }}
                                                                    />
                                                                </div>
                                                                </div>

                                                                <div className="col-lg-4">
                                                                        <EventosExcel ref={this.excelRef} anio={this.state.filtroYYYY} data={this.state.datax}/>
                                                                        <button className="btn btn-secondary d-block w-100 py-1 btnCallToActionCMS btnCallAzul"
                                                                        onClick={async () => {
                                                                            if (!this.state.filtroYYYY) {alert("Por favor seleccione un año");return;}

                                                                            await this.getDataXLS();
                                                                            if (this.excelRef.current) { 
                                                                                this.excelRef.current.exportarExcel();
                                                                            }
                                                                        }}
                                                                        > DESCARGAR GANTT .xls</button>                                                                      
                                                                </div>
                                                                
                                                                <div className="col-lg-6">
                                                                <div className="mb-0" >
                                                                 {/* <div className="col-12">
                                                                    <a href="#" 
                                                                        className="btnAnadirCat noneEvent btnCallToActionCMS"
                                                                        onClick={() => this.generaCalendarioEnPDF()}>
                                                                        {this.state.loading ? 'Procesando...' : 'GENERAR CALENDARIO .pdf'}
                                                                    </a>
                                                                </div>          */}
                                                                </div>
                                                                </div>

                                                            </div>

                                                            </div>

                                                            <div className="col-lg-3" style={{height:"80px"}} >
                                                            <div className="row">
                                                                <div className='divSectorSearch_Panel '>
                                                                <input 
                                                                    type="text" 
                                                                    value={this.state.searchText} 
                                                                    id="busqueda" 
                                                                    placeholder="NOMBRE DEL EVENTO" 
                                                                    onChange={this.handleInputTextChange} 
                                                                    name="search" 
                                                                />
                                            
                                                                <input 
                                                                    type="submit" 
                                                                    defaultValue="Buscar" 
                                                                    onClick={() => this.searchEvent()}  
                                                                />
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        <div className="clear" />

                                                         <div className="col-lg-12"  >
                                                            <div className="row">
                                                                <div className="col-12 text-center">
                                                                    <p style={{color:"red"}}>{this.state.mensajeResultado}</p>    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>	

                                            </div> 

                                            <div className="divTablaPage_Panel">
                                                <div className="table-responsive">
                                                    <table  border={1} cellSpacing={0}>
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th style={{ width: 470 }}>Título</th>
                                                                <th>Tipo</th>
                                                                <th>Sector</th>
                                                                <th>Fecha de evento</th>
                                                                <th className='text-center'>Usuario</th>
                                                                <th className='text-center'>Activo</th>
                                                                <th style={{ width: 80 }}>Estado</th>
                                                                <th style={{ width: 80 }}>Acción</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.data.length > 0 ? 
                                                                this.state.data.map((item) => {
                                                                    let usuario = item.even_UsuarioCreacion;
                                                                    let dataUsuario = this.state.users.find((item) => item.nUsuCodigo === usuario);
                                                                    let userText = "";

                                                                    if(dataUsuario){
                                                                        userText = dataUsuario.nUsuNombreCompleto;
                                                                    }else{
                                                                        userText = `Usuario de ID ${usuario}`;
                                                                    }

                                                                    return (
                                                                        <tr key={item.even_Id}>
                                                                            <td className='font-weight-bold text-primary'>
                                                                                {item.even_Id}
                                                                            </td>
                                                                            <td>
                                                                                {item.even_Titulo}
                                                                            </td>
                                                                            
                                                                            <td>{item.even_Tipo}</td>
                                                                            <td>
                                                                                {item.sSector}
                                                                            </td>
                                                                            
                                                                            <td>
                                                                                {Moment(item.even_FechaInicio).format('dddd DD, MMMM YYYY')}
                                                                            </td>
                                                                            <td className='text-center'>
                                                                                {userText}
                                                                            </td>
                                                                            <td className='text-center'>
                                                                                {item.even_Activo === "1" ? 
                                                                                    <i className='fas fa-check text-success fa-2x'></i> 
                                                                                : 
                                                                                    <i className='fas fa-times text-danger fa-2x'></i>
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {item.even_Estado === "P" 
                                                                                ?
                                                                                    <span style={{width: 25, height: 25}} className='d-inline-flex ModuloInactivo'></span>
                                                                                :
                                                                                    <span style={{width: 25, height: 25}} className='d-inline-flex ModuloVer'></span>
                                                                                }
                                                                            </td>
                                                                            <td className='px-3'>
                                                                                <button 
                                                                                    onClick={() => this.editEvent(item.even_Id)} 
                                                                                    className="btn btn-primary btn-sm btn-primary__tool" 
                                                                                    type="button"
                                                                                >
                                                                                    <i className="fas fa-pen fa-sm"></i>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            :
                                                                <tr>
                                                                    <td colSpan={10}>
                                                                        Sin eventos disponibles
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {this.state.data.length > 0 &&
                                                    <div>
                                                        {this.paginationTable()}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            :
                <Error StatusCode={this.state.response.StatusCode} StatusMessage={this.state.response.StatusMessage}></Error>
        )
    }
}

export default Eventos